import { useEffect } from "react";

export const useRefetchLoop = (
  callback: () => void,
  secondsInterval: number,
) => {
  useEffect(() => {
    const interval = setInterval(() => {
      callback();
    }, secondsInterval * 1000);

    return () => clearInterval(interval);
  }, [callback, secondsInterval]);
};
